import React from 'react'
import { DataGrid } from '../../common/datagrid/ResponsiveDataGrid';
import CustomLoadingOverlay from '../../common/datagrid/CustomLoadingOverlay'
import CustomToolbar from '../../common/datagrid/CustomToolbar'

const SalesFileList = ({
  apiRef,
  columns,
  files,
  error,
  loading,
  columnVisibilityModel
}) => {
  return (
    <div style={{ display: 'flex', height: '250px', minWidth: '100%' }}>
    <div style={{ flexGrow: 1, minWidth: '100%' }}>
      <DataGrid
        apiRef={apiRef}
        rows={files ? files : []}
        columns={columns}
        components={{
          Toolbar: CustomToolbar,
          LoadingOverlay: CustomLoadingOverlay,
        }}
        componentsProps={{
          toolbar: { fileName: '매출발주서_리스트' },
        }}
        loading={loading}
        initialState={{ pinnedColumns: { right: ['actions'] } }}
        columnVisibilityModel={columnVisibilityModel? columnVisibilityModel: []}
      />
    </div>
  </div>
  )
}

export default SalesFileList
